import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const SetoZine = () => {
  return (
    <section className="py-24 bg-neutral-900 text-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="w-full lg:w-1/2 relative"
          >
            <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl relative">
              <img 
                src="https://images.unsplash.com/photo-1490430657723-4d607c1503fc?w=800&h=1000&fit=crop&q=80" 
                alt="瀨戶內海的重生 攝影小誌" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex items-end p-8">
                <span className="bg-teal-500 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider">
                  新出版 New Release
                </span>
              </div>
            </div>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="w-full lg:w-1/2 space-y-6"
          >
            <div className="flex items-center gap-3 text-teal-400 mb-2">
              <SafeIcon name="BookOpen" />
              <span className="font-semibold tracking-wider font-sm">影響力故事出版</span>
            </div>
            
            <h2 className="text-3xl md:text-5xl font-bold leading-tight">
              《瀨戶內海的重生》<br/>攝影小誌
            </h2>
            
            <div className="space-y-4 text-gray-300 text-lg leading-relaxed">
              <p>
                2025 年，相信世代帶領台灣青年走進日本瀨戶內海，展開一場關於地方、藝術與未來想像的見學旅行。
              </p>
              <p>
                瀨戶內海曾面臨產業污染與人口外流的困境，透過「瀨戶內國際藝術祭」，重新連結藝術、自然與居民生活，逐漸走出一條屬於島嶼的重生之路。
              </p>
              <p>
                本小誌記錄了夥伴們與土地相遇、對話與反思的過程。為<strong className="text-white">中日雙語版本</strong>，收錄見學夥伴的文字、影像與在瀨戶內海的見學觀察。
              </p>
            </div>
            
            <div className="pt-8">
              <div className="bg-white/10 border border-white/20 p-6 rounded-xl flex flex-col sm:flex-row items-center justify-between gap-6">
                <div>
                  <p className="text-sm text-gray-400 mb-1">支持我們的心血結晶</p>
                  <p className="text-2xl font-bold text-teal-400">捐款 400 元<span className="text-white text-lg font-normal ml-2">獲得小誌！</span></p>
                </div>
                <button className="btn-primary whitespace-nowrap w-full sm:w-auto">立即支持索取</button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SetoZine;